import React from "react";
import { MRT_ShowHideColumnsButton as WMRT_ShowHideColumnsButton } from "material-react-table";

function MRT_ShowHideColumnsButton(props) {
  return <WMRT_ShowHideColumnsButton {...props} />;
}

export default MRT_ShowHideColumnsButton;
